const Colors = {
  primary: 'rgba(0, 15, 86, 1)',
  secondary: 'rgba(255, 190, 59, 1)',
  tertiary: 'rgba(108, 179, 63, 1)',
  indigoBlue: 'rgba(0, 15, 86, 1)',  //Named TransAlta Colour
  darkBlue: 'rgba(0, 15, 86, 0.8)',
  brightBlue: 'rgba(88, 224, 246, 1)',  //Named TransAlta Colour
  lightBlue: 'rgba(88, 224, 246, 0.4)',
  brightGreen: 'rgba(110, 247, 138, 1)',  //Named TransAlta Colour
  green: '#589F35',
  warange: 'rgba(110, 247, 138, 0.55)',
  mouseDown: '#0096D6',
  orange: 'rgba(255, 190, 59, 1)', //Named TransAlta Colour
  yellow: 'rgba(255, 255, 28, 1)',  //Named TransAlta Colour
  orangeRed: 'rgba(230, 120, 57, 1)',  //Named TransAlta Colour
  red: 'rgba(210, 65, 85, 1)'  //Named TransAlta Colour
};
export default Colors;
